import { render, staticRenderFns } from "./RoleSwitch.vue?vue&type=template&id=40e9c6c6&"
import script from "./RoleSwitch.vue?vue&type=script&lang=js&"
export * from "./RoleSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports